//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.CutParameters.js";
import "../CAM/CAM.ChipControl.js";
import "../CAM/CAM.TurnConcaveCornerControl.js";
import "../CAM/CAM.ContourAngle.js";
import "../CAM/CAM.CutDwell.js";
import "../CAM/CAM.FacesSequence.js";
import "../CAM/CAM.FinishDwell.js";
import "../CAM/CAM.TurnGrooveCornerControl.js";
import "../CAM/CAM.InitialProfilePlunge.js";
import "../CAM/CAM.MinCutDepth.js";
import "../CAM/CAM.MinCutLength.js";
import "../CAM/CAM.StepoverBuilder.js";
import "../CAM/CAM.MultiRamp.js";
import "../CAM/CAM.TurnCornerControl.js";
import "../CAM/CAM.TurnDirection.js";
import "../CAM/CAM.ProfileStrategy.js";
import "../CAM/CAM.RampingMode.js";
import "../CAM/CAM.ReliefCut.js";
import "../CAM/CAM.ReliefPlunge.js";
import "../CAM/CAM.TurnRoughFinishTestCut.js";
import "../CAM/CAM.SpringPasses.js";
import "../CAM/CAM.StopPosition.js";
import "../CAM/CAM.TurnStock.js";
import "../CAM/CAM.TurnCutterClearance.js";
import "../CAM/CAM.TurnOverlap.js";
let d=[[[0,"AdditionalProfiling",1,0],[0,"AllowUndercut",1,0],[1,"ChipControl",0,"CAM.ChipControl",0],[0,"CleanupControl",1,0],[1,"ConcaveCornerControl",0,"CAM.TurnConcaveCornerControl",0],[1,"ContourDiameterAngle",0,"CAM.ContourAngle",0],[1,"ContourFaceAngle",0,"CAM.ContourAngle",0],[1,"ContourLevelAngle",0,"CAM.ContourAngle",0],[1,"ContourSteepAngle",0,"CAM.ContourAngle",0],[0,"CutConnection",1,0],[1,"CutDwell",0,"CAM.CutDwell",0],[0,"CutFillets",1,0],[0,"ExtendAtStart",1,0],[1,"FacesSequence",0,"CAM.FacesSequence",0],[1,"FinishDwell",0,"CAM.FinishDwell",0],[0,"FinishPasses",1,0],[1,"GrooveCornerControl",0,"CAM.TurnGrooveCornerControl",0],[1,"InitialProfilePlunge",0,"CAM.InitialProfilePlunge",0],[1,"MinCutDepth",0,"CAM.MinCutDepth",0],[1,"MinCutLength",0,"CAM.MinCutLength",0],[1,"MultiPasses",0,"CAM.StepoverBuilder",0],[1,"MultiRamp",0,"CAM.MultiRamp",0],[1,"NormalCorner",0,"CAM.TurnCornerControl",0],[0,"OmitLastPass",1,0],[0,"ProfileCutRegions",1,0],[1,"ProfileDirection",0,"CAM.TurnDirection",0],[1,"ProfileStrategy",0,"CAM.ProfileStrategy",0],[1,"RampingMode",0,"CAM.RampingMode",0],[1,"ReliefCut",0,"CAM.ReliefCut",0],[1,"ReliefPlunge",0,"CAM.ReliefPlunge",0],[1,"SecondaryTestCut",0,"CAM.TurnRoughFinishTestCut",0],[1,"ShallowCorner",0,"CAM.TurnCornerControl",0],[1,"SpringPasses",0,"CAM.SpringPasses",0],[1,"StopPosition",0,"CAM.StopPosition",0],[1,"TestCut",0,"CAM.TurnRoughFinishTestCut",0],[1,"TurnBlankStock",0,"CAM.TurnStock",0],[1,"TurnCutterClearance",0,"CAM.TurnCutterClearance",0],[1,"TurnOverlap",0,"CAM.TurnOverlap",0],[1,"TurnPartStock",0,"CAM.TurnStock",0],[1,"TurnProfileStock",0,"CAM.TurnStock",0]],[],[]];
SPLM.CAM.TurnCutParameters = class extends SPLM.CAM.CutParameters{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.TurnCutParameters";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;